import { baseConf } from './base'

export type Config = typeof conf

export const conf = {
  ...baseConf,
  acquisitionTracking: {
    googleAnalytics: {
      id: 'UA-6331378-16',
    },
    googleTagManager: {
      id: 'GTM-NQ3XB9',
      layer: 'dataLayerAt1333',
    },
  },
  accountHub: {
    security: 'https://account.grammarly.com/security',
  },
  api: {
    analytics: 'https://gateway.grammarly.com/analytics/api',
    auth: 'https://auth.grammarly.com/auth/v3',
    authV4: 'https://auth.grammarly.com/auth/v4/api',
    capi: 'https://capi.grammarly.com/api',
    institution: 'https://gateway.grammarly.com/institution/api',
    redirect: 'https://redirect.grammarly.com/redirect/way',
    subscription: 'https://subscription.grammarly.com',
    dox: 'https://dox.grammarly.com',
    cheetah: 'https://capi.grammarly.com/api/configuration/cheetah/v1/settings',
    zoomWebinar:
      'https://applications.zoom.us/api/v1/pardot/registration/FhlbeOAHRsGyoy15OysALQ?state=VkVSU046MDAwplODttRjTeyU9UYQnSCuzDipwU4CRcD2VoUxAQFB8CScLZrF6tj6D0r9U5BfOw1JVoM',
    facadeServer: 'https://www.grammarly.com',
    settingsRegistry: 'https://gateway.grammarly.com/settings-registry/v1',
  },
  domains: {
    cookie: '.grammarly.com',
    main: 'grammarly.com',
    superhuman: 'superhuman.com',
  },
  recaptcha: {
    salesforce: {
      urls: {
        original: 'https://www.google.com/recaptcha/enterprise.js',
        global: 'https://www.recaptcha.net/recaptcha/enterprise.js',
      },
      siteKey: '6Lc5WvspAAAAAKT3CDovSA-frA7oP4ElmuW0JY8A',
    },
    got: {
      urls: {
        original: 'https://www.google.com/recaptcha/enterprise.js',
        global: 'https://www.recaptcha.net/recaptcha/enterprise.js',
      },
      siteKey: '6Lc5WvspAAAAAKT3CDovSA-frA7oP4ElmuW0JY8A',
    },
    enterprise: {
      urls: {
        original: 'https://www.google.com/recaptcha/enterprise.js',
        global: 'https://www.recaptcha.net/recaptcha/enterprise.js',
      },
      siteKey: '6LdSYv0UAAAAAF5PhF0Z1rK7QiupkyRBy1ebiFc4',
    },
    visible: {
      urls: {
        original: 'https://www.google.com/recaptcha/api.js',
        global: 'https://www.recaptcha.net/recaptcha/api.js',
      },
      siteKey: '6LdytLcUAAAAACE166s-sdC7FELY1-pyo0mAO62V',
    },
    visibleEnterprise: {
      sitekey: '6LcTmlolAAAAAKcDAZQE0o-1rBJT4R2xzuz6zqaA',
    },
  },
  socialOAuth: {
    facebook: {
      clientId: '945246385586366',
    },
    google: {
      clientId: '913728339568-tjccmfojammmqs9q0kunokb507mpjqum.apps.googleusercontent.com',
    },
    apple: {
      clientId: 'com.grammarly.service',
    },
  },
  support: {
    urls: {
      main: 'https://support.grammarly.com',
      newRequest: 'https://support.grammarly.com/hc/en-us/requests/new',
      signUpEmailVerification: 'https://support.grammarly.com/hc/en-us/articles/4409116491149',
      signInEmailFailure: 'https://support.grammarly.com/hc/en-us/articles/4409703520909',
    },
    email: 'support@grammarly.com',
  },
  tracking: {
    felog: {
      url: 'https://f-log-at.grammarly.io',
    },
    femetrics: {
      url: 'https://website.femetrics.grammarly.io/batch/import',
    },
    gnar: {
      url: 'https://gnar.grammarly.com',
    },
    fullStory: {
      host: 'fullstory.com',
      script: 'edge.fullstory.com/s/fs.js',
      orgId: 'o-1B1GJK-na1',
    },
    sprig: {
      environmentId: 'TSFBsQOLWCAu',
    },
  },
  urls: {
    main: 'https://www.grammarly.com',
    mainForText: 'grammarly.com',
    editor: 'https://app.grammarly.com',
    editorNewDoc: 'https://app.grammarly.com/ddocs/new',
    aiEditorNewDoc: 'https://coda.grammarly.com/newdoc',
    demoEditor: 'https://demo.grammarly.com',
    capiWs: 'wss://capi.grammarly.com/freews',
    social: {
      facebook: 'https://www.facebook.com/grammarly',
      instagram: 'https://www.instagram.com/grammarly/',
      github: 'https://github.com/grammarly',
      linkedin: 'https://www.linkedin.com/company/grammarly',
      pinterest: 'https://www.pinterest.com/grammarly',
      twitter: 'https://twitter.com/grammarly',
      tumblr: 'https://grammarly.tumblr.com',
      youtube: 'https://www.youtube.com/user/theGrammarly',
      twitterEng: 'https://twitter.com/grammarlyeng',
      wikipedia: 'https://en.wikipedia.org/wiki/Grammarly',
    },
    developer: {
      home: 'https://developer.grammarly.com',
    },
  },
  transcend: {
    id: '1c1f8e90-47d0-4bba-a1a2-472d59b002a2',
  },
}
